import Link from 'next/link'

import Icons from '@/shared/components/icon/Icons'
import { Caption, Text } from '@/shared/components/typography'
import useHash from '@/shared/hooks/useHash'

type TicketInfoProps = {
  parkinglotSeq: number
  parkinglotName: string
  couponName: string
  price: number
  usingLabel: string
  type: string
}

const TicketInfo = ({ parkinglotSeq, parkinglotName, couponName, price, usingLabel, type }: TicketInfoProps) => {
  const { getHashAll } = useHash()
  const hash = getHashAll()
  return (
    <div className="relative z-10 py-[2px] before:absolute before:top-0 before:h-1/2 before:w-full before:bg-main-050 before:content-['']">
      <div className="w-[calc(100% - 32px)] sticky mx-4 mb-6 mt-5 flex min-h-[128px] flex-col items-center gap-1 rounded-[10px] bg-010 px-4 py-[22px] shadow-[0_2px_4px_0px_rgba(0,0,0,0.1)]">
        <Link
          href={`/map?type=${type}&id=${parkinglotSeq}${hash}`}
          className="flex w-full items-center justify-center gap-1"
        >
          <Caption level="caption2" color="text070" className="overflow-hidden text-ellipsis whitespace-nowrap">
            {parkinglotName}
          </Caption>
          <Icons.LeftIcon stroke="currentColor" color="#6D7D90" />
        </Link>
        <Text level="text1" color="text090" weight="bold" className="text-center">
          {couponName} <span className="text-main-050">{price.toLocaleString()}원</span>
        </Text>
        <Caption level="caption2" color="text090">
          {usingLabel}
        </Caption>
      </div>
    </div>
  )
}

export default TicketInfo
